import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { GlassHouseShelfTalkerPostCardContentViewModel } from './glass-house-shelf-talker-post-card-content-view-model';
import { ShelfTalkerCardContentComponent } from '../../shared/shelf-talker-card-content.component';

@Component({
  selector: 'app-glass-house-shelf-talker-post-card-content',
  templateUrl: './glass-house-shelf-talker-post-card-content.component.html',
  styleUrls: ['./glass-house-shelf-talker-post-card-content.component.scss'],
  providers: [GlassHouseShelfTalkerPostCardContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseShelfTalkerPostCardContentComponent extends ShelfTalkerCardContentComponent {
  constructor(
    public viewModel: GlassHouseShelfTalkerPostCardContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
